import {Fragment, type FC} from "react"
import {Tabs, Tab} from "@mui/material"
import {useTranslation} from "react-i18next"

type Props = {
  tabValue: string
  setTabValue: (tabValue: string) => void
}

const NavigationTopBar: FC<Props> = (props) => {
  const {tabValue, setTabValue} = props
  const {t} = useTranslation()
  return (
    <Fragment>
      <Tabs
        value={tabValue}
        TabIndicatorProps={{
          title: "indicator",
          sx: {
            backgroundColor: "#242D35",
            height: 2,
            borderRadius:'4px',
          },
        }}
        sx={{
          backgroundColor: "#fff",
          marginTop: "8px",
          ".MuiButtonBase-root": {
            padding: "16px 35px 10px 35px",
            color: "#595958",
            textTransform: "capitalize",
            fontSize: "16px",
          },
          ".Mui-selected": {
            fontWeight: "600",
            color: "#242D35 !important",
          },
        }}
      >
        <Tab
          label={t("Overview")}
          value="Overview"
          tabIndex={0}
          onClick={() => setTabValue("Overview")}
        />
        <Tab
          label={t("Discover")}
          value="Discover"
          tabIndex={1}
          onClick={() => setTabValue("Discover")}
        />
      </Tabs>
    </Fragment>
  )
}

export default NavigationTopBar
